import { render, staticRenderFns } from "./UploadReports.vue?vue&type=template&id=0ba5514a&"
import script from "./UploadReports.vue?vue&type=script&lang=js&"
export * from "./UploadReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports